import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Home, Loader2, RefreshCw } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const day = (iso) => (iso ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "never");

export const PriceRefresh = () => {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get("/guides-property-refresh").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (!s?.running) return undefined; const t = setInterval(load, 8000); return () => clearInterval(t); }, [s?.running, load]);
  if (!s) return null;
  const start = async () => {
    if (!window.confirm(`Refresh home prices for all ${s.total} Italian and French guides? It pulls the latest market data, re-checks buying and yearly costs, rewrites the price examples in the property chapter and rebuilds the PDFs. Uses some AI credit and takes about a minute per guide.`)) return;
    try { const r = await api.post("/guides-property-refresh"); toast.success(`Refreshing ${r.data.started} guides`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const res = s.results || [];
  const failed = res.filter((r) => !r.ok);
  return (
    <div className={`border p-5 mb-6 flex flex-wrap items-center gap-4 ${s.due ? "border-[#C59B27] bg-[#FBF4E2]" : "border-[#E2D9CC] bg-[#FAF7F2]"}`} data-testid="price-refresh">
      <Home className="w-5 h-5 text-[#C59B27]" strokeWidth={1.5} />
      <div className="mr-auto">
        <p className="eyebrow mb-1">Home prices</p>
        {s.running
          ? <p className="text-sm" data-testid="price-refresh-progress">Refreshing… {res.length} of {s.total} done{s.current ? ` · now ${s.current}` : ""}</p>
          : <p className="text-sm text-[#6B5B4E]" data-testid="price-refresh-status">
              {s.due ? `${s.due} of ${s.total} guides are due a refresh. ` : `All ${s.total} guides are up to date. `}
              Oldest refresh {day(s.oldest_refresh)}{s.next_due && !s.due ? `, next due ${day(s.next_due)}` : ""}. You'll get an email reminder when it's due.
            </p>}
        {!s.running && failed.length > 0 && <p className="text-xs text-red-700 mt-1" data-testid="price-refresh-failed">Last run couldn't refresh: {failed.map((f) => f.town).join(", ")}</p>}
      </div>
      <Button onClick={start} disabled={s.running} className="rounded-none" data-testid="price-refresh-button">
        {s.running ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}{s.running ? "Refreshing…" : "Refresh home prices"}
      </Button>
    </div>
  );
};
